import React from 'react'
import Product from '../Product/Product'
import Error from '../Error/Error'
import { useQuery } from 'react-query'
import axios from 'axios'
import Loading from '../Loading/Loading'
import useUserWishlist from '../../hooks/useUserWishlist'

export default function FeaturedProducts({ products }) {

    const { isLoading: wishlistLoading, isError: wishlistError, data: wishlistData, refetch: wishlistRefetch } = useUserWishlist()
    let wishlistItems = []
    wishlistData?.data.map(item => wishlistItems.push(item._id));





    const getFeaturedProducts = () => {
        return axios.get('https://ecommerce.routemisr.com/api/v1/products');
    }


    const { isLoading, isFetching, isError, data, refetch } = useQuery('featuredProducts', getFeaturedProducts)


    return <>

        <div className="container py-2">

            {
                isLoading && <Loading />
            }
            {
                isError && <Error />
            }

            <h2>Featured Products</h2>
            <div className="row">
                {
                    data?.data.data.map(product => <Product key={product.id} product={product} wishlist={wishlistItems} refetch={refetch} wishlistRefetch={wishlistRefetch} />)
                }
            </div>
        </div>
    </>


}
